// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"be7abf4f","278":"37691174","596":"cdf5bc4e"}[chunkId] + ".css";
};